import { Text } from '@mantine/core';
import Link from '@/components/Link';
import {
  CLIENT_PORTFOLIO_VIEW,
  useHasAnyPermission,
} from '@/models/permissions';

export type PortfolioOwnerRef = {
  kind: 'client_company' | 'contact';
  id: number | string;
};

export function portfolioOwnerPath(owner: PortfolioOwnerRef) {
  return owner.kind === 'client_company'
    ? `/client-companies/${owner.id}`
    : `/client-contacts/${owner.id}`;
}

export function PortfolioOwnerLink({
  owner,
  label,
  size = 'sm',
}: {
  owner: PortfolioOwnerRef;
  label?: string;
  size?: 'xs' | 'sm';
}) {
  const canOpen = useHasAnyPermission(CLIENT_PORTFOLIO_VIEW);
  const text =
    label ??
    (owner.kind === 'client_company'
      ? 'Company portfolio'
      : 'Contact portfolio');
  if (!canOpen)
    return (
      <Text fz={size} c="dimmed">
        {text}
      </Text>
    );
  return (
    <Link to={`~${portfolioOwnerPath(owner)}`}>
      <Text fz={size}>{text}</Text>
    </Link>
  );
}
